var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "00610a080500121e22d09c030e3c12f2.png",
    width: 156,
    height: 156
});